// Formats a given season in the form:

import { Season } from "operations";

//    `<season> <year>`
export const seasonNameFormatter = (season: Season | null | undefined) =>
  `${season?.name ?? ""}${season?.year ? ` ${season.year}` : ""}`;

export const toDropDownOption = <T extends { value: string; label: string }>(
  season: Season
): T => {
  return {
    value: season.id,
    label: seasonNameFormatter(season),
  } as T;
};

// Compares Seasons by following order of precedence:
// 1) year -> Descending
// 2) name -> Ascending
export const seasonComparator = (a: Season, b: Season) => {
  const yearCmp = (a: number, b: number) => {
    if (a === b) return 0;
    else if (a > b) return -1;
    else return 1;
  };
  const yearValue = yearCmp(a.year ?? -1, b.year ?? -1);
  return yearValue ? yearValue : a.name.localeCompare(b.name);
};
